import Legenda from 'components/core/Legenda';
import { ptBR } from 'date-fns/locale';
import { useMemo } from 'react';
import { ListGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { selectFunc } from 'redux/features/auth/authSlice';
import { getMedicosAgenda } from 'utils/agenda';
import styles from './Sidebar.module.css';

export default function Sidebar({
  medicoSelecionado,
  setMedicoSelecionado,
  dataSelecionada,
  setDataSelecionada,
  setAgendaContext,
}) {
  const func = useSelector(selectFunc);
  const medicosVisiveis = useMemo(() => getMedicosAgenda({ isFunc: Boolean(func) }), [func]);

  return (
    <div>
      <ListGroup style={{ fontSize: '0.875rem' }} className="shadow-sm">
        {medicosVisiveis.map((medico) => {
          const ativo = medicoSelecionado?.codMed === medico.codMed;
          return (
            <ListGroup.Item
              key={medico.codMed}
              active={ativo}
              onClick={() => {
                setMedicoSelecionado(medico);
                setAgendaContext(null);
              }}
              className={`border-start-1 border-end-1 py-1 ${styles.item} ${
                ativo ? styles.itemActive : styles.itemInactive
              }`}
              style={{ cursor: 'pointer' }}
            >
              {medico.apelido}
            </ListGroup.Item>
          );
        })}
      </ListGroup>

      {/* 💡 MELHORIA: Substituído width inline por classe nativa w-100 */}
      <div className="mt-1 w-100" style={{ overflow: 'hidden' }}>
        <DatePicker
          selected={dataSelecionada}
          onChange={setDataSelecionada}
          dateFormat="dd/MM/yyyy"
          locale={ptBR}
          inline
          todayButton="Hoje"
          dropdownMode="select"
          showMonthDropdown
          showYearDropdown
          adjustDateOnChange
          calendarClassName="react-datepicker--inline-constrained"
        />
      </div>

      <div className="mt-auto pt-1">
        <Legenda minimizadoPadrao={true} />
      </div>
    </div>
  );
}
